import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import MUIDataTable from 'mui-datatables';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import DateBanner from './DateBanner.jsx';
import DoorLauncher from './DoorLauncher';

import LockIcon from '../icons/LockIcon.jsx';
import LockOpenIcon from '../icons/LockOpenIcon.jsx';
import LockAlertIcon from '../icons/LockAlertIcon.jsx';
import LockClockIcon from '../icons/LockClockIcon.jsx';

const drawerWidth = 180;

const useStyles = makeStyles((theme) => ({
  dataTable: {
    width: '100%',
    '& th': {
      padding: '0px',
    },
    '& td': {
      padding: '0px',
    },
  },
  headerIcon: {
    position: 'relative',
    right: '-90px',
  },
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '100%',
    minHeight: '600px',
  },
  dataTableActions: {
    '& span': {
      paddingLeft: '0px',
      paddingRight: '7px',
      '& svg': {
        verticalAlign: 'bottom',
      },
    },
  },
  content: {
    // TODO: Remove duplicate 'content' key
    flexGrow: 1,
    position: 'absolute',
    top: '65px',
    bottom: '0px',
    left: '0px',
    right: '0px',
    overflowy: 'auto',
  },
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  tabBar: {
    boxShadow: 'none',
    position: 'fixed',
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  banner: {
    marginLeft: '66%',
  },
  badge: {
    backgroundColor: theme.palette.warning.light,
  },
  divider: {
    borderLeft: `1px solid ${theme.palette.neutral.main}`,
    height: '2em',
    marginLeft: '0.3em',
  },
  profile: {
    padding: '5px 10px 5px 10px',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '1.3em',
    flexShrink: 0,
  },
  logo: {
    maxWidth: drawerWidth,
    maxHeight: 50, // TODO: set based on height of app bar
  },
  tabLayout: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  flexSpacer: {
    width: '260px',
  },
}));

const DoorControl = (props) => {
  // TODO: mobile styling if needed
  // const isMobile = useMediaQuery((mqTheme) => mqTheme.breakpoints.down('xs'));
  const title = 'Door Control';
  const classes = useStyles();
  const theme = useTheme();

  const toolbarBackground = theme.palette.type === 'dark' ? '#1f1f1f' : '#ffffff';
  const toolbarForeground = theme.palette.type === 'dark' ? '#ffffff' : '#43425d';

  const columns = [
    {
      name: 'door',
      label: 'Door',
      options: {
        filter: true,
      },
    },
    {
      name: 'state',
      label: 'State',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'actions',
      label: 'Actions',
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  const tableOptions = {
    filter: false,
    print: false,
    search: false,
    download: false,
    viewColumns: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    showFirstButton: true,
    showLastButton: true,
    selectableRowsOnClick: true,
  };

  const formattedControlData = () => {
    return props.gridData.map((item) => {
      const actions = (
        <div className={classes.dataTableActions}>
          <span>
            <LockIcon style={{ color: '#616161' }} />
          </span>
          <span>
            <LockOpenIcon style={{ color: '#388e3c' }} />
          </span>
          <span>
            <LockAlertIcon style={{ color: '#f9a825 ' }} />
          </span>
          <span>
            <LockClockIcon color="secondary" />
          </span>
        </div>
      );

      const doorState = [];
      const doorName = (
        <Typography color={item.state === 'Open' ? 'error' : 'initial'}>{item.name}</Typography>
      );
      return [doorName, doorState, actions];
    });
  };

  const renderedDoorControls = props.gridData.length ? (
    <MUIDataTable
      data={formattedControlData()}
      columns={columns}
      options={tableOptions}
      className={classes.dataTable}
    />
  ) : (
    <>
      <div className={classes.newcardcredential}>
        <Typography key="message">No Door Controls Available</Typography>
      </div>
    </>
  );

  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <DoorLauncher title={title}>
      <div className={classes.root}>
        <AppBar position="fixed" className={classes.tabBar}>
          <Toolbar style={{ backgroundColor: toolbarBackground, color: toolbarForeground }}>
            <div className={classes.tabLayout}>
              <img
                className={classes.logo}
                src={`${window.location.origin}/images/${
                  theme.palette.type === 'dark' ? 'premisys_logo_dark.svg' : 'premisys_logo.svg'
                }`}
                alt="PremiSys"
              />
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                className={classes.menuButton}
              >
                <MenuIcon />
              </IconButton>
              {/*   <Hidden smDown implementation="css"> */}
              <DateBanner className={classes.banner} />
              {/*   </Hidden> */}
              <div className={classes.flexSpacer} />
            </div>
          </Toolbar>
        </AppBar>
      </div>
      <main className={classes.content}>{renderedDoorControls}</main>
    </DoorLauncher>
  );
};

export default DoorControl;
